import React, { Component } from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { connectModal } from 'redux-modal';
import { submit } from 'redux-form';
import Select from 'react-select';
import Button from 'react-bootstrap-button-loader';
import get from 'lodash/get';
import { renderToString } from 'react-dom/server';

import { parseStyle } from '../../../../utils/helpers/style_parser';
import { AdminApi } from '../../../../api';
import { setLoader, removeLoader } from '../../../../actions';
import TemplatesForm from '../../../publisher/templates/TemplatesForm';

class TemplatesModal extends Component {
  state = {
    template: {},
  };

  componentDidMount() {
    const { template } = this.props;
    this.setState({ template });
  }

  onFormSubmit(values) {
    const { dispatch, handleHide } = this.props;

    const label = values.template.label;

    const reactSnippet = () => {
      const styles = parseStyle(label.styles);

      return (
        <div style={{ ...styles, display: 'block' }}>
          <a style={{ color: styles.color, margin: 0, padding: 0 }} rel="noopener noreferrer" href='https://www.jobadx.com' target='_blank'>
            Sponsored by JobAdx
          </a>
        </div>
      );
    };

    label.snippet = renderToString(reactSnippet());

    const templateData = {
      ...values.template,
      custom_label: values.template.custom_label === 'true',
      label: {
        styles: {
          textAlign: get(values, 'template.label.styles.textAlign', 'left'),
          fontSize: parseInt(get(values, 'template.label.styles.fontSize', 18), 10),
          color: {
            r: parseInt(get(values, 'template.label.styles.color.r', 0), 10),
            g: parseInt(get(values, 'template.label.styles.color.g', 0), 10),
            b: parseInt(get(values, 'template.label.styles.color.b', 0), 10),
            a: parseFloat(get(values, 'template.label.styles.color.a', 1.0))
          },
			    backgroundColor: {
            r: parseInt(get(values, 'template.label.styles.backgroundColor.r', 255), 10),
            g: parseInt(get(values, 'template.label.styles.backgroundColor.g', 255), 10),
            b: parseInt(get(values, 'template.label.styles.backgroundColor.b', 255), 10),
            a: parseFloat(get(values, 'template.label.styles.backgroundColor.a', 1.0))
          },
          margin: {
            top: parseInt(get(values, 'template.label.styles.margin.top', 0), 10),
            right: parseInt(get(values, 'template.label.styles.margin.right', 0), 10),
            bottom: parseInt(get(values, 'template.label.styles.margin.bottom', 0), 10),
            left: parseInt(get(values, 'template.label.styles.margin.left', 0), 10)
          },
          padding: {
            top: parseInt(get(values, 'template.label.styles.padding.top', 0), 10),
            right: parseInt(get(values, 'template.label.styles.padding.right', 0), 10),
            bottom: parseInt(get(values, 'template.label.styles.padding.bottom', 0), 10),
            left: parseInt(get(values, 'template.label.styles.padding.left', 0), 10)
          }
        },
        snippet: get(values, 'template.label.snippet', ''),
      },
      snippet: get(values, 'template.snippet', ''),
    };
    delete templateData.default;
    delete templateData.uuid;

    const args = [this.state.template.id, { template: { ...templateData } }];

    dispatch(setLoader('TemplateForm'));
    dispatch(AdminApi.actions.websiteTemplateUpdate.post(...args, (_error, success) => {
      if (success) {
        if (!this.state.template.default && values.template.default) {
          const params = { template: { default: true } };

          dispatch(AdminApi.actions.templateUpdateDefault.post(this.state.template.id, params, (_defaultError, defaultSuccess) => {
            if (defaultSuccess) {
              dispatch(AdminApi.actions.websiteTemplate());
              dispatch(removeLoader('TemplateForm'));
              handleHide();
            }
          }));
        } else {
          dispatch(AdminApi.actions.websiteTemplate());
          dispatch(removeLoader('TemplateForm'));
          handleHide();
        }
      } else {
        dispatch(removeLoader('TemplateForm'));
      }
    }));
  }

  handleTemplateChange({ value }) {
    const { templates } = this.props;

    const template = templates.find(t => t.id === value);
    this.setState({ template });
  }

  render() {
    const { show, handleHide, dispatch, isLoading, templates, website } = this.props;
    const templateOptions = templates.map(t => ({ label: `${t.name} ${t.default ? '(Default)' : ''}`, value: t.id, clearableValue: false }));

    return (
      <Modal bsSize='large' show={show} onHide={handleHide}>
        <Modal.Header>
          <Modal.Title>{`Edit ${website.name} Website Templates`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={12}>
              <Select
                type='text'
                name='websiteTemplateId'
                label='Website Template'
                value={this.state.template.id}
                clearable={false}
                onChange={this.handleTemplateChange.bind(this)}
                options={templateOptions}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={12}>
              {
                this.state.template.id && (
                  <TemplatesForm
                    handleTemplateSubmit={this.onFormSubmit.bind(this)}
                    website={website}
                    template={this.state.template}
                    isAdmin
                  />
                )
              }
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={handleHide}>Close</Button>
          <Button
            loading={isLoading}
            bsStyle='info'
            onClick={() => dispatch(submit('TemplateForm'))}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const ResourceModal = connectModal({
  name: 'adminWebsiteTemplateModal'
});

const mapStateToProps = (state) => {
  const { loader, modal: { adminWebsiteTemplateModal }, form: { TemplateForm: adminTemplateForm } } = state;
  const isLoading = loader.includes('TemplateForm');
  const website = get(adminWebsiteTemplateModal, 'props.website', []);
  const templates = get(adminWebsiteTemplateModal, 'props.templates', []);

  return { isLoading, templates, website, adminTemplateForm };
};

export default connect(mapStateToProps)(ResourceModal(TemplatesModal));
